if (!customElements.get('kal-footer')) {
  customElements.define('kal-footer', class KalFooter extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 749px)');
      this.details = Array.from(this.querySelectorAll('[data-footer-details]'));
      this.onChange = () => this.syncDetails();
      this.details.forEach((detail) => {
        detail.dataset.userToggled = 'false';
        detail.querySelector('summary')?.addEventListener('click', (event) => {
          if (!this.media.matches || detail.dataset.accordionMobile !== 'true') {
            event.preventDefault();
            detail.open = true;
            detail.dataset.userToggled = 'false';
            return;
          }
          detail.dataset.userToggled = 'true';
        });
      });
      this.media.addEventListener('change', this.onChange);
      this.syncDetails(true);
    }

    disconnectedCallback() {
      this.media?.removeEventListener('change', this.onChange);
    }

    syncDetails(initial = false) {
      this.details.forEach((detail) => {
        const shouldCollapse = this.media.matches && detail.dataset.accordionMobile === 'true';
        if (shouldCollapse && !initial && detail.dataset.userToggled === 'true') return;
        detail.dataset.syncing = 'true';
        detail.open = !shouldCollapse;
        if (!shouldCollapse) detail.dataset.userToggled = 'false';
        requestAnimationFrame(() => { delete detail.dataset.syncing; });
      });
    }
  });
}